import { Component, EventEmitter, Input, OnInit, Output, TemplateRef, inject } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { AuthService, SettingsService, SearchService, CONFIG } from '@gallaghercp/core-frontend';
import { APP_CONFIG } from '@core-app/app.config';

@Component({
    selector: 'core-client-search',
    templateUrl: './search.component.html',
    standalone: false,
})
export class SearchComponent implements OnInit {
    protected search = inject(SearchService);
    settings = inject(SettingsService);
    private readonly modalService = inject(BsModalService);
    protected auth = inject(AuthService);

    // Decorators to emit hamburger boolean of false to close responsive nav on search submit
    @Output() closeSidenavHamburgerNav = new EventEmitter<boolean>();
    @Output() closeTopnavHamburgerNav = new EventEmitter<boolean>();
    @Input() hamburgerNav?: boolean;
    @Input() isSearchButtonIcon?: boolean;
    @Input() isDesktop?: boolean;

    isTopNavSearch?: boolean;
    modalRef?: BsModalRef;
    noResultPreview = (APP_CONFIG as CONFIG).search?.noResultPreview;
    // searchIconColor config was removed. Icon color now derives from global CSS var set by nav bg contrast.

    ngOnInit(): void {
        this.hamburgerNav = false;
        this.settings.isTopNavigation().subscribe((state: any) => {
            this.isTopNavSearch = state;
        });
    }

    openModal(template: TemplateRef<any>) {
        this.modalRef = this.modalService.show(template, Object.assign({}, { class: 'modal-search' }));
    }

    closeMobileMenu(evt: boolean) {
        this.closeTopnavHamburgerNav.emit(evt);
    }
}
